import React from 'react'
import styled from 'styled-components'
import {Link} from 'gatsby'
var LinkStyled = styled(Link)`
color: ${({ theme }) => theme.colors['secondary']};
text-decoration:none;
&:hover{
    color: ${({ theme }) => theme.colors['primary']};
    text-decoration:underline;
}
`
var Wrapper = styled.div`
margin:20px 10px 0 0 ;

`
export default function Breadcrumbs(props) {
    var LinkList = props.link_list || [
        {"href":"htt...","title":"Test"},
        {"href":"htt...","title":"Test"},
        {"href":"htt...","title":"Test"},
        {"href":"htt...","title":"Test"},
        {"href":"htt...","title":"Test"},
    ]
    var Current = props.current || ""
    return (
        <Wrapper>
           { LinkList.map((x,index)=><><LinkStyled to={x.href.replace("https://www.airasia.com/flights","")}
           key={"breadeCrumbsWrap"+index}>{x.title}</LinkStyled> > </> ) }
           <span>{Current}</span>
        </Wrapper>
    )
}
